import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  alternate?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  alternate = false
}: SectionProps) {
  return <section id={id} className={`
        relative py-20 md:py-28 px-6 md:px-8
        ${alternate ? 'bg-cream-dark' : 'bg-cream'}
        ${className}
      `} data-id="element-527">
      {/* Subtle top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-brown/10 to-transparent" data-id="element-528" />

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="max-w-2xl mx-auto" data-id="element-529">
        {children}
      </motion.div>
    </section>;
}